/**
 * API helpers para notifications.
 * Usa apiGet/apiPost do shared (com JWT auth automatico).
 * API_URL ja tem /api no fim — paths NAO devem ter /api/.
 */
import { apiGet, apiPost } from '@/shared/services/api';

export interface NotificationItem {
  id: number;
  kind: string;
  title: string | null;
  message: string;
  priority: number;
  createdAt: string;
  readAt: string | null;
  targetCharIdx: number | null;
  targetUserNum: number | null;
  source: string | null;
}

export interface NotificationListResp {
  items: NotificationItem[];
  total: number;
  unread: number;
}

export interface UnreadCountResp { unread: number; }

export interface NotificationStatsItem { kind: string; total: number; last24h: number; }
export interface NotificationStatsResp { byKind: NotificationStatsItem[]; totalUnreadGm: number; }

export const NotificationsAPI = {
  myList(page = 1, pageSize = 20, onlyUnread = false) {
    return apiGet<NotificationListResp>('/notifications/me', {
      page, pageSize, onlyUnread: String(onlyUnread),
    });
  },

  myUnreadCount() {
    return apiGet<UnreadCountResp>('/notifications/me/unread-count');
  },

  markRead(id: number) {
    return apiPost<void>(`/notifications/${id}/read`, {});
  },

  markAllRead() {
    return apiPost<void>('/notifications/me/read-all', {});
  },

  adminList(page = 1, pageSize = 50, kind?: string, priorityMax?: number) {
    const params: Record<string, string | number> = { page, pageSize };
    if (kind) params.kind = kind;
    if (priorityMax !== undefined) params.priorityMax = priorityMax;
    return apiGet<NotificationListResp>('/admin/notifications', params);
  },

  adminStats() {
    return apiGet<NotificationStatsResp>('/admin/notifications/stats');
  },

  adminReadAll() {
    return apiPost<void>('/admin/notifications/read-all', {});
  },

  adminCreate(payload: {
    kind: string;
    title?: string;
    message: string;
    priority?: number;
    targetCharIdx?: number;
    targetUserNum?: number;
    source?: string;
  }) {
    return apiPost<{ notifId: number }>('/admin/notifications/create', payload);
  },
};
